import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { LessonFacade } from '../facades/lesson.facade';

export function lessonCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const lessonFacade = inject(LessonFacade);
        lessonFacade.clear();

        return true;
    };
}
